// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-item {
  position: relative;
  padding: 16px;
  background: #080707;
  border-radius: 8px;
  cursor: pointer;
}
.order-item:hover {
  background: var(--primary-color);
}
.order-item > a {
  text-decoration: none;
  color: #fff;
}
.order-item__inner {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}
.order-item__inner > div:nth-child(1) {
  width: 2%;
}
@media (max-width: 767px) {
  .order-item__inner > div:nth-child(1) {
    min-width: 40px;
  }
}
.order-item__inner > div:nth-child(2) {
  width: 3%;
}
.order-item__inner > div:nth-child(3) {
  width: 12%;
}
@media (max-width: 1700px) {
  .order-item__inner > div:nth-child(3) {
    width: 25%;
  }
}
@media (max-width: 767px) {
  .order-item__inner > div:nth-child(3) {
    display: none;
  }
}
.order-item__inner > div:nth-child(4) {
  width: 15%;
}
@media (max-width: 1700px) {
  .order-item__inner > div:nth-child(4) {
    width: 25%;
  }
}
@media (max-width: 992px) {
  .order-item__inner > div:nth-child(4) {
    width: 50%;
  }
}
@media (max-width: 767px) {
  .order-item__inner > div:nth-child(4) {
    width: 50%;
  }
}
.order-item__inner > div:nth-child(5) {
  width: 13%;
}
@media (max-width: 1700px) {
  .order-item__inner > div:nth-child(5) {
    display: none;
  }
}
.order-item__inner > div:nth-child(6) {
  width: 10%;
}
@media (max-width: 1700px) {
  .order-item__inner > div:nth-child(6) {
    display: none;
  }
}
.order-item__inner > div:nth-child(7) {
  width: 10%;
}
@media (max-width: 1700px) {
  .order-item__inner > div:nth-child(7) {
    display: none;
  }
}
.order-item__inner > div:nth-child(8) {
  width: 10%;
  color: #fff;
  /* @media (max-width:1700px){
            display: none;
          }*/
}
@media (max-width: 767px) {
  .order-item__inner > div:nth-child(8) {
    display: block;
    width: 40%;
  }
}
.order-item__inner > div:nth-child(9) {
  width: 10%;
  color: #fff;
}
@media (max-width: 1200px) {
  .order-item__inner > div:nth-child(9) {
    display: none;
  }
}
.order-item__inner > div:nth-child(10):not(.participant-item__date) {
  width: 10%;
  color: #fff;
}
@media (max-width: 1400px) {
  .order-item__inner > div:nth-child(10):not(.participant-item__date) {
    display: none;
  }
}
.order-item__inner > div.participant-item__date {
  width: 20%;
  color: #fff;
}
@media (max-width: 1400px) {
  .order-item__inner > div.participant-item__date {
    width: 50%;
  }
}
.order-item__wrapper {
  display: flex;
  align-items: center;
}
@media (max-width: 767px) {
  .order-item__wrapper {
    flex-wrap: wrap;
  }
}
.order-item__content {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.4s ease;
}
.order-item__content-header {
  margin: 30px 0;
  font-size: 20px;
  color: #fff;
}
.order-item__content-inner {
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px 35px;
}
.order-item__content-block {
  display: flex;
  width: calc(50% - 20px);
  gap: 20px;
}
.order-item__content-block:last-child {
  flex-direction: column;
}
.order-item__content-select {
  max-width: 300px;
  width: 100%;
}
.order-item__content-input {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.order-item__content-textarea {
  width: 100%;
}
.order-item__content-textarea textarea {
  min-height: 350px;
}
.order-item__content-wrapper {
  min-height: 0;
  transition: all 0.3s;
  visibility: hidden;
  overflow: hidden;
  opacity: 0;
}
.order-item__content-item {
  width: calc(50% - 20px);
  padding: 16px;
  background: #131313;
  border-radius: 8px;
}
@media (max-width: 992px) {
  .order-item__content-item {
    width: 100%;
  }
  .order-item__content-item.order-item__user-name {
    display: block;
  }
  .order-item__content-item.order-item__status {
    display: block;
  }
  .order-item__content-item.order-item__type {
    display: block;
  }
}
.order-item__content-item span {
  color: #fff;
  font-weight: bold;
}
.order-item__select {
  margin-right: 15px;
}
.order-item__id {
  width: 3%;
  min-width: 60px;
}
.order-item__avatar {
  width: 2%;
  min-width: 50px;
  position: relative;
}
@media (max-width: 600px) {
  .order-item__avatar {
    display: none;
  }
}
.order-item__unread-badge {
  position: absolute;
  top: -6px;
  right: 4px;
  background-color: #e53935;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);
  z-index: 2;
  border: 2px solid #080707;
}
.order-item__status {
  width: 5%;
  min-width: 140px;
  /* @media (max-width:992px){
        display: none;
      }*/
}
.order-item__ip {
  width: 5%;
  min-width: 150px;
}
@media (max-width: 992px) {
  .order-item__ip {
    display: none;
    min-width: 250px;
    padding: 20px 0;
    align-items: center;
  }
}
.order-item__date {
  width: 5%;
  min-width: 180px;
  padding-left: 20px;
}
@media (max-width: 992px) {
  .order-item__date {
    min-width: 250px;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.order-item__name {
  color: #f4f4f4;
  min-width: 150px;
  width: 25%;
}
@media (max-width: 1700px) {
  .order-item__name {
    width: 15%;
  }
}
@media (max-width: 767px) {
  .order-item__name {
    display: none;
  }
}
.order-item__img {
  width: 50px;
}
.order-item__controls {
  position: absolute;
  right: 15px;
  display: flex;
  justify-content: flex-end;
  min-width: 50px;
  width: 5%;
  gap: 20px;
}
@media (max-width: 767px) {
  .order-item__controls {
    align-items: center;
  }
}
.order-item__controls a {
  display: inline-flex;
  transition: all 0.3s ease;
}
.order-item__controls a svg {
  width: 25px;
  height: 15px;
}
.order-item__controls a svg path {
  fill: #fff;
}
.order-item__controls a:hover svg {
  width: 25px;
  height: 15px;
}
.order-item__controls a:hover svg path {
  fill: #ff0000;
  stroke: #ff0000;
}
.order-item__controls a:active {
  transform: scale(0.95);
}
.order-item.active .order-item__content {
  grid-template-rows: 1fr;
}
.order-item.active .order-item__content-wrapper {
  visibility: visible;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/OrderItem/OrderItem.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EAEE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAFF;AAGE;EACE,gCCVG;ADSP;AAGE;EACE,qBAAA;EACA,WAAA;AADJ;AAGE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AADJ;AAIM;EACE,SAAA;AAFR;AAGQ;EAFF;IAGI,eAAA;EAAR;AACF;AAEM;EACE,SAAA;AAAR;AAGM;EACE,UAAA;AADR;AAEQ;EAFF;IAGI,UAAA;EACR;AACF;AAAQ;EALF;IAMI,aAAA;EAGR;AACF;AADM;EACE,UAAA;AAGR;AAFQ;EAFF;IAGI,UAAA;EAKR;AACF;AAJQ;EALF;IAMI,UAAA;EAOR;AACF;AANQ;EARF;IASI,UAAA;EASR;AACF;AAPM;EACE,UAAA;AASR;AARQ;EAFF;IAGI,aAAA;EAWR;AACF;AATM;EACE,UAAA;AAWR;AAVQ;EAFF;IAGI,aAAA;EAaR;AACF;AAXM;EACE,UAAA;AAaR;AAZQ;EAFF;IAGI,aAAA;EAeR;AACF;AAZM;EACE,UAAA;EACA,WAAA;EACA;;YAAA;AAgBR;AAbQ;EANF;IAOI,cAAA;IACA,UAAA;EAgBR;AACF;AAdM;EACE,UAAA;EACA,WAAA;AAgBR;AAfQ;EAHF;IAII,aAAA;EAkBR;AACF;AAhBM;EACE,UAAA;EACA,WAAA;AAkBR;AAjBQ;EAHF;IAII,aAAA;EAoBR;AACF;AAlBM;EACE,UAAA;EACA,WAAA;AAoBR;AAnBQ;EAHF;IAII,UAAA;EAsBR;AACF;AAfE;EACE,aAAA;EACA,mBAAA;AAiBJ;AAfI;EAJF;IAKI,eAAA;EAkBJ;AACF;AAhBE;EACE,aAAA;EACA,uBAAA;EAEA,wCAAA;AAiBJ;AAhBI;EACE,cAAA;EACA,eAAA;EACA,WAAA;AAkBN;AAhBI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AAkBN;AAhBI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAkBN;AAjBM;EACE,sBAAA;AAmBR;AAhBI;EACE,gBAAA;EACA,WAAA;AAkBN;AAhBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAkBN;AAhBI;EACE,WAAA;AAkBN;AAjBM;EACE,iBAAA;AAmBR;AAhBI;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAkBN;AAhBI;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAkBN;AAjBM;EALF;IAMI,WAAA;EAoBN;EAnBM;IACE,cAAA;EAqBR;EAnBM;IACE,cAAA;EAqBR;EAnBM;IACE,cAAA;EAqBR;AACF;AAnBM;EACE,WAAA;EACA,iBAAA;AAqBR;AAjBE;EACE,kBAAA;AAmBJ;AAjBE;EACE,SAAA;EACA,eAAA;AAmBJ;AAjBE;EACE,SAAA;EACA,eAAA;EACA,kBAAA;AAmBJ;AAlBI;EAJF;IAKI,aAAA;EAqBJ;AACF;AAjBE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,wCAAA;EACA,UAAA;EACA,yBAAA;AAmBJ;AAhBE;EACE,SAAA;EACA,gBAAA;EACA;;QAAA;AAoBJ;AAhBE;EACE,SAAA;EACA,gBAAA;AAkBJ;AAjBI;EAHF;IAII,aAAA;IACA,gBAAA;IACA,eAAA;IAEA,mBAAA;EAmBJ;AACF;AAjBE;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;AAmBJ;AAlBI;EAJF;IAKI,gBAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,yBAAA;EAqBJ;AACF;AAnBE;EACE,cAAA;EAEA,gBAAA;EACA,UAAA;AAoBJ;AAnBI;EALF;IAMI,UAAA;EAsBJ;AACF;AArBI;EARF;IASI,aAAA;EAwBJ;AACF;AArBE;EACE,WAAA;AAuBJ;AArBE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,SAAA;AAuBJ;AAtBI;EARF;IASI,mBAAA;EAyBJ;AACF;AAxBI;EACE,oBAAA;EACA,yBAAA;AA0BN;AAzBM;EACE,WAAA;EACA,YAAA;AA2BR;AA1BQ;EACE,UAAA;AA4BV;AAxBQ;EACE,WAAA;EACA,YAAA;AA0BV;AAzBU;EACE,aAAA;EACA,eAAA;AA2BZ;AAvBM;EACE,sBAAA;AAyBR;AApBI;EACE,uBAAA;AAsBN;AArBM;EACE,mBAAA;EACA,UAAA;AAuBR","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n.order-item{\r\n  $self:&;\r\n  position: relative;\r\n  padding: 16px;\r\n  background: #080707;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  &:hover{\r\n    background: $main;\r\n  }\r\n  >a{\r\n    text-decoration: none;\r\n    color: #fff;\r\n  }\r\n  &__inner{\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    //justify-content: space-between;\r\n    > div{\r\n      &:nth-child(1){\r\n        width: 2%;\r\n        @media (max-width:767px){\r\n          min-width: 40px;\r\n        }\r\n      }\r\n      &:nth-child(2){\r\n        width: 3%;\r\n\r\n      }\r\n      &:nth-child(3){\r\n        width: 12%;\r\n        @media (max-width:1700px){\r\n          width: 25%;\r\n        }\r\n        @media (max-width:767px){\r\n          display: none;\r\n        }\r\n      }//15%\r\n      &:nth-child(4){\r\n        width: 15%;\r\n        @media (max-width:1700px){\r\n          width: 25%;\r\n        }\r\n        @media (max-width:992px){\r\n          width: 50%;\r\n        }\r\n        @media (max-width:767px){\r\n          width: 50%;\r\n        }\r\n      }//25%\r\n      &:nth-child(5){\r\n        width: 13%;\r\n        @media (max-width:1700px){\r\n          display: none;\r\n        }\r\n      }\r\n      &:nth-child(6){\r\n        width: 10%;\r\n        @media (max-width:1700px){\r\n          display: none;\r\n        }\r\n      }\r\n      &:nth-child(7){\r\n        width: 10%;\r\n        @media (max-width:1700px){\r\n          display: none;\r\n        }\r\n\r\n      }//50%\r\n      &:nth-child(8){\r\n        width: 10%;\r\n        color: #fff;\r\n        /* @media (max-width:1700px){\r\n                  display: none;\r\n                }*/\r\n        @media (max-width:767px){\r\n          display: block;\r\n          width: 40%;\r\n        }\r\n      }//60%\r\n      &:nth-child(9){\r\n        width: 10%;\r\n        color: #fff;\r\n        @media (max-width:1200px){\r\n          display: none;\r\n        }\r\n      }//70%\r\n      &:nth-child(10):not(.participant-item__date){\r\n        width: 10%;\r\n        color: #fff;\r\n        @media (max-width:1400px){\r\n          display: none;\r\n        }\r\n      }//80%\r\n      &.participant-item__date{\r\n        width: 20%;\r\n        color: #fff;\r\n        @media (max-width:1400px){\r\n          width: 50%;\r\n        }\r\n      }\r\n    }\r\n    @media (max-width:767px){\r\n      //flex-wrap: wrap;\r\n    }\r\n  }\r\n  &__wrapper{\r\n    display: flex;\r\n    align-items: center;\r\n    //justify-content: space-between;\r\n    @media (max-width:767px){\r\n      flex-wrap: wrap;\r\n    }\r\n  }\r\n  &__content{\r\n    display: grid;\r\n    grid-template-rows: 0fr;\r\n    //overflow: hidden;\r\n    transition: grid-template-rows 0.4s ease;\r\n    &-header{\r\n      margin: 30px 0;\r\n      font-size: 20px;\r\n      color:#fff;\r\n    }\r\n    &-inner{\r\n      position: relative;\r\n      width: 100%;\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      gap: 20px 35px;\r\n    }\r\n    &-block{\r\n      display: flex;\r\n      width: calc(50% - 20px);\r\n      gap:20px;\r\n      &:last-child{\r\n        flex-direction: column;\r\n      }\r\n    }\r\n    &-select{\r\n      max-width: 300px;\r\n      width: 100%;\r\n    }\r\n    &-input{\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap:10px;\r\n    }\r\n    &-textarea{\r\n      width: 100%;\r\n      textarea{\r\n        min-height: 350px;\r\n      }\r\n    }\r\n    &-wrapper{\r\n      min-height: 0;\r\n      transition:all 0.3s;\r\n      visibility: hidden;\r\n      overflow: hidden;\r\n      opacity: 0;\r\n    }\r\n    &-item{\r\n      width: calc(50% - 20px);\r\n      padding: 16px;\r\n      background: #131313;\r\n      border-radius: 8px;\r\n      @media (max-width:992px){\r\n        width: 100%;\r\n        &#{$self}__user-name{\r\n          display: block;\r\n        }\r\n        &#{$self}__status{\r\n          display: block;\r\n        }\r\n        &#{$self}__type {\r\n          display: block;\r\n        }\r\n      }\r\n      span{\r\n        color:#fff;\r\n        font-weight: bold;\r\n      }\r\n    }\r\n  }\r\n  &__select{\r\n    margin-right: 15px;\r\n  }\r\n  &__id{\r\n    width: 3%;\r\n    min-width: 60px;\r\n  }\r\n  &__avatar{\r\n    width: 2%;\r\n    min-width: 50px;\r\n    position: relative; // Добавлено позиционирование для бейджа\r\n    @media (max-width:600px){\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  // Стили для каунтера на аватарке заявки\r\n  &__unread-badge {\r\n    position: absolute;\r\n    top: -6px;\r\n    right: 4px; // Слегка сдвинуто, чтобы красиво висеть на краю круглой аватарки\r\n    background-color: #e53935;\r\n    color: #ffffff;\r\n    font-size: 11px;\r\n    font-weight: 700;\r\n    min-width: 20px;\r\n    height: 20px;\r\n    border-radius: 10px; // Делает круглым для однозначных чисел и овальным для двузначных\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0 5px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);\r\n    z-index: 2;\r\n    border: 2px solid #080707; // Обводка в цвет фона, чтобы визуально отделить от аватарки\r\n  }\r\n\r\n  &__status{\r\n    width: 5%;\r\n    min-width: 140px;\r\n    /* @media (max-width:992px){\r\n          display: none;\r\n        }*/\r\n  }\r\n  &__ip{\r\n    width: 5%;\r\n    min-width: 150px;\r\n    @media (max-width:992px){\r\n      display: none;\r\n      min-width: 250px;\r\n      padding: 20px 0;\r\n      //    display: flex;\r\n      align-items: center;\r\n    }\r\n  }\r\n  &__date{\r\n    width: 5%;\r\n    min-width: 180px;\r\n    padding-left: 20px;\r\n    @media (max-width:992px){\r\n      min-width: 250px;\r\n      padding: 20px 0;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: flex-end;\r\n    }\r\n  }\r\n  &__name{\r\n    color:#f4f4f4;\r\n    //min-width: 30%;\r\n    min-width: 150px;\r\n    width: 25%;\r\n    @media (max-width:1700px){\r\n      width: 15%;\r\n    }\r\n    @media (max-width:767px){\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  &__img{\r\n    width: 50px;\r\n  }\r\n  &__controls{\r\n    position: absolute;\r\n    right: 15px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    min-width: 50px;\r\n    width: 5%;\r\n    gap: 20px;\r\n    @media (max-width:767px){\r\n      align-items: center;\r\n    }\r\n    a{\r\n      display: inline-flex;\r\n      transition: all 0.3s ease;\r\n      svg{\r\n        width:25px;\r\n        height:15px;\r\n        path{\r\n          fill: #fff\r\n        }\r\n      }\r\n      &:hover{\r\n        svg{\r\n          width:25px;\r\n          height:15px;\r\n          path{\r\n            fill: #ff0000;\r\n            stroke:#ff0000\r\n          }\r\n        }\r\n      }\r\n      &:active{\r\n        transform: scale(0.95);\r\n      }\r\n    }\r\n  }\r\n  &.active{\r\n    #{$self}__content{\r\n      grid-template-rows: 1fr;\r\n      &-wrapper{\r\n        visibility: visible;\r\n        opacity: 1;\r\n      }\r\n    }\r\n\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);\r\n$primary: #131313;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
